import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FiShoppingBag, FiUsers , FiGrid,
  FiTrendingUp, FiPackage, FiTag, FiSettings
} from 'react-icons/fi';
import { TbCurrencyRupee } from 'react-icons/tb';

import api from '../../utils/api';
import toast from 'react-hot-toast';

const VendorDashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalOrders: 0,
    todayOrders: 0,
    todaySales: 0,
    todayRoomSales: 0,
    openTables: 0,
    pendingOrders: 0,
    totalMenuItems: 0,
    totalCaptains: 0,
    todayCashExpenses: 0,
    todayOnlineExpenses: 0,
    todayTotalExpenses: 0,
    remainingCash: 0
  });

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  const fetchDashboardStats = async () => {
    try {
      const response = await api.get('/vendor/dashboard/stats');
      
      if (response.data.success) {
        setStats(response.data.data);
      } else {
        toast.error('Failed to fetch dashboard stats');
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
      toast.error('Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  };

  const quickActions = [
    {
      title: 'Menu Management',
      icon: <FiPackage />,
      path: '/vendor/menu',
      color: '#1976d2',
      bgColor: '#e3f2fd'
    },
    {
      title: 'Orders',
      icon: <FiShoppingBag />,
      path: '/vendor/orders',
      color: '#388e3c',
      bgColor: '#e8f5e9'
    },
    {
      title: 'Open Tables',
      icon: <FiGrid />,
      path: '/vendor/open-tables',
      color: '#f57c00',
      bgColor: '#fff3e0'
    },
    {
      title: 'QR Codes',
      icon: <FiGrid />,
      path: '/vendor/qr-codes',
      color: '#7b1fa2',
      bgColor: '#f3e5f5'
    },
    {
      title: 'Captains',
      icon: <FiUsers />,
      path: '/vendor/captains',
      color: '#0277bd',
      bgColor: '#e1f5fe'
    },
    {
      title: 'Coupons',
      icon: <FiTag />,
      path: '/vendor/coupons',
      color: '#c2185b',
      bgColor: '#fce4ec'
    },
    {
      title: 'Reports',
      icon: <FiTrendingUp />,
      path: '/vendor/reports',
      color: '#00695c',
      bgColor: '#e0f2f1'
    },
    {
      title: 'Settings',
      icon: <FiSettings />,
      path: '/vendor/settings',
      color: '#5d4037',
      bgColor: '#efebe9'
    }
  ];

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[#2596be]"></div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-7xl mx-auto min-h-screen">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-1">Dashboard</h1>
        <p className="text-gray-600 text-sm">Welcome back! Here's what's happening today.</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {/* <div 
          onClick={() => navigate('/vendor/orders')}
          className="bg-white rounded-xl shadow-md p-4 hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1 border-2 border-transparent hover:border-[#2596be]"
        >
          <div className="flex items-center gap-3">
            <div className="bg-blue-100 p-3 rounded-lg">
              <FiShoppingBag className="text-2xl text-blue-600" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-800">{stats.totalOrders}</h3>
              <p className="text-gray-600 text-xs mt-1">Total Orders</p>
            </div>
          </div>
        </div> */}

        <div 
          onClick={() => navigate('/vendor/orders')}
          className="bg-white rounded-xl shadow-md p-4 hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1 border-2 border-transparent hover:border-[#2596be]"
        >
          <div className="flex items-center gap-3">
            <div className="bg-blue-100 p-3 rounded-lg">
              <FiShoppingBag className="text-2xl text-blue-600" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-800">{stats.todayOrders}</h3>
              <p className="text-gray-600 text-xs mt-1">Today's Orders</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-md p-4 hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-green-500">
          <div className="flex items-center gap-3">
            <div className="bg-green-100 p-3 rounded-lg">
              <TbCurrencyRupee className="text-2xl text-green-600" />
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-gray-800">₹{stats.todaySales?.toLocaleString() || 0}</h3>
              <p className="text-gray-600 text-xs mt-1">Today's Sales</p>
              {(stats.todayCashSales > 0 || stats.todayOnlineSales > 0) && (
                <div className="text-xs mt-1 space-y-1">
                  {stats.todayCashSales > 0 && (
                    <div className="text-green-600 font-medium">💵 Cash: ₹{stats.todayCashSales?.toLocaleString() || 0}</div>
                  )}
                  {stats.todayOnlineSales > 0 && (
                    <div className="text-blue-600 font-medium">💳 Online: ₹{stats.todayOnlineSales?.toLocaleString() || 0}</div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-md p-4 hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-indigo-500">
          <div className="flex items-center gap-3">
            <div className="bg-indigo-100 p-3 rounded-lg">
              <FiTrendingUp className="text-2xl text-indigo-600" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-800">₹{stats.todayRoomSales?.toLocaleString() || 0}</h3>
              <p className="text-gray-600 text-xs mt-1">Today Room Sales</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 p-4 border border-gray-100 hover:border-red-400">
  <div className="flex items-center gap-3">

    {/* Icon */}
    <div className="bg-red-50 p-2.5 rounded-lg flex-shrink-0">
      <TbCurrencyRupee className="text-xl text-red-600" />
    </div>

    {/* Content */}
    <div className="flex-1">

      {/* Top Section */}
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-bold text-gray-800 leading-tight">
          ₹{stats.todayTotalExpenses?.toLocaleString() || 0}
        </h3>

        <span className="text-[10px] text-gray-500">
          Total Expenses
        </span>
      </div>

      {/* Online / Cash */}
      <div className="flex justify-between text-[11px] text-gray-600 mt-1">
        <span>
          Online: ₹{stats.todayOnlineExpenses?.toLocaleString() || 0}
        </span>
        <span>
          Cash: ₹{stats.todayCashExpenses?.toLocaleString() || 0}
        </span>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-100 my-1"></div>

      {/* Remaining Cash */}
      <div className="flex justify-between items-center">
        <span className="text-[11px] text-gray-600 font-medium">
          Remaining Cash
        </span>

        <span
          className={`text-[11px] font-semibold px-2 py-0.5 rounded ${
            stats.remainingCash >= 0
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          ₹{stats.remainingCash?.toLocaleString() || 0}
        </span>
      </div>

    </div>
  </div>
</div>

        <div 
          onClick={() => navigate('/vendor/open-tables')}
          className="bg-white rounded-xl shadow-md p-4 hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1 border-2 border-transparent hover:border-orange-500"
        >
          <div className="flex items-center gap-3">
            <div className="bg-orange-100 p-3 rounded-lg">
              <FiGrid className="text-2xl text-orange-600" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-800">{stats.openTables}</h3>
              <p className="text-gray-600 text-xs mt-1">Open Tables</p>
            </div>
          </div>
        </div>

        <div 
          onClick={() => navigate('/vendor/orders')}
          className="bg-white rounded-xl shadow-md p-4 hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1 border-2 border-transparent hover:border-purple-500"
        >
          <div className="flex items-center gap-3">
            <div className="bg-purple-100 p-3 rounded-lg">
              <FiShoppingBag className="text-2xl text-purple-600" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-800">{stats.pendingOrders}</h3>
              <p className="text-gray-600 text-xs mt-1">Pending Orders</p>
            </div>
          </div>
        </div>

        <div 
          onClick={() => navigate('/vendor/menu')}
          className="bg-white rounded-xl shadow-md p-4 hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1 border-2 border-transparent hover:border-cyan-500"
        >
          <div className="flex items-center gap-3">
            <div className="bg-cyan-100 p-3 rounded-lg">
              <FiPackage className="text-2xl text-cyan-600" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-800">{stats.totalMenuItems}</h3>
              <p className="text-gray-600 text-xs mt-1">Menu Items</p>
            </div>
          </div>
        </div>

        <div 
          onClick={() => navigate('/vendor/captains')}
          className="bg-white rounded-xl shadow-md p-4 hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1 border-2 border-transparent hover:border-pink-500"
        >
          <div className="flex items-center gap-3">
            <div className="bg-pink-100 p-3 rounded-lg">
              <FiUsers className="text-2xl text-pink-600" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-800">{stats.totalCaptains}</h3>
              <p className="text-gray-600 text-xs mt-1">Captains</p>
            </div>
          </div>
        </div>
      </div>

      {/* Keyboard Shortcuts Guide */}
      <div className="bg-white rounded-xl shadow-md p-6 mb-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="bg-indigo-100 p-3 rounded-lg">
            <FiSettings className="text-2xl text-indigo-600" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-gray-800">Keyboard Shortcuts</h2>
            <p className="text-gray-600 text-sm">Quick access to all features</p>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Navigation Shortcuts */}
          <div className="bg-gray-50 rounded-lg p-4">
            <h3 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-blue-600">🧭</span> Navigation
            </h3>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Dashboard</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+D</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Orders</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+O</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Menu Management</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+M</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Open Tables</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+T</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">QR Codes</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+Q</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Captains</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+C</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Stock Management</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+S</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Inventory</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+V</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Room Management</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+R</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Booking Management</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+B</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Banquet</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+K</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Coupons</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+U</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Notifications</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+N</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Expenses</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+W</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Reports</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+P</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Subscription</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+X</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Subscription History</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+H</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Profile</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+F</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Settings</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+G</kbd>
              </div>
            </div>
          </div>

          {/* Management Shortcuts */}
          <div className="bg-gray-50 rounded-lg p-4">
            <h3 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-green-600">⚡</span> Quick Actions
            </h3>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Add Order</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+A</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Add Category</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+Y</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Add Sub-Category</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+Z</kbd>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Add Menu Item</span>
                <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs font-mono">Alt+I</kbd>
              </div>
            </div>
          </div>

          {/* System Info */}
          <div className="bg-gray-50 rounded-lg p-4">
            <h3 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-purple-600">ℹ️</span> System Info
            </h3>
            <div className="space-y-3">
              <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
                <p className="text-sm text-blue-800 font-medium mb-1">📋 Total Shortcuts</p>
                <p className="text-xs text-blue-600">19 Navigation + 4 Quick Actions = 23 Total</p>
              </div>
              <div className="p-3 bg-green-50 rounded-lg border border-green-200">
                <p className="text-sm text-green-800 font-medium mb-1">🚀 How to Use</p>
                <p className="text-xs text-green-600">Press Alt+shortcut keys anywhere in the vendor portal</p>
              </div>
              <div className="p-3 bg-purple-50 rounded-lg border border-purple-200">
                <p className="text-sm text-purple-800 font-medium mb-1">⚡ Pro Tip</p>
                <p className="text-xs text-purple-600">All shortcuts use Alt key - no conflicts with typing!</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
          <p className="text-sm text-blue-800">
            <strong>💡 Tip:</strong> Press Alt+shortcut keys anywhere in the vendor portal to quickly navigate or open modals. 
            All shortcuts use Alt key to avoid conflicts with typing!
          </p>
        </div>
      </div>

      {/* Quick Actions */}
      {/* <div className="section-header">
        <h2>Quick Actions</h2>
      </div>
      <div className="quick-actions-grid">
        {quickActions.map((action, index) => (
          <button
            key={index}
            className="action-card"
            onClick={() => navigate(action.path)}
            style={{ borderColor: action.color }}
          >
            <div 
              className="action-icon"
              style={{ backgroundColor: action.bgColor, color: action.color }}
            >
              {action.icon}
            </div>
            <h3>{action.title}</h3>
          </button>
        ))}
      </div> */}
    </div>
  );
};

export default VendorDashboard;
